import { render, staticRenderFns } from "./PromoterCompetitorsContainer.vue?vue&type=template&id=e600a07a&"
import script from "./PromoterCompetitorsContainer.vue?vue&type=script&lang=js&"
export * from "./PromoterCompetitorsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports